import { render, staticRenderFns } from "./UserToggle.vue?vue&type=template&id=7671e87e&scoped=true&"
import script from "./UserToggle.vue?vue&type=script&lang=js&"
export * from "./UserToggle.vue?vue&type=script&lang=js&"
import style0 from "./UserToggle.vue?vue&type=style&index=0&id=7671e87e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7671e87e",
  null
  
)

export default component.exports